"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketAccelerateConfigurationInput_1 = require("./PutBucketAccelerateConfigurationInput");
var PutBucketAccelerateConfigurationOutput_1 = require("./PutBucketAccelerateConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketAccelerateConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketAccelerateConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?accelerate"
    },
    input: {
        shape: PutBucketAccelerateConfigurationInput_1.PutBucketAccelerateConfigurationInput
    },
    output: {
        shape: PutBucketAccelerateConfigurationOutput_1.PutBucketAccelerateConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketAccelerateConfiguration.js.map